import(/* webpackMode: "eager" */ "/vercel/path0/app/events/page.tsx");
